import * as z from "zod";

export const getInternationalReadiness = {
  name: "getInternationalReadiness" as const,
  input: z.null(),
  output: z.object({
    /** Customs fields the team's return lanes require; empty when no cross-border lane exists. */
    requiredFields: z.array(
      z.enum(["hsCode", "originCountry", "manufacturerId"]),
    ),
    /** Returns currently tagged delayed-in-customs (non-terminal statuses). */
    stuckReturnCount: z.number(),
    catalog: z.object({
      total: z.number(),
      valid: z.number(),
      readinessPercent: z.number(),
      missingHsCode: z.number(),
      missingOriginCountry: z.number(),
      missingManufacturerId: z.number(),
    }),
  }),
};
